module.exports = __webpack_public_path__ + "static/media/valley.f0ccb15e.png";